import styles from "../ProductStatusBox.module.scss";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import InStore24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/InStore24PxOutlined";
import Email24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Email24PxOutlined";
import { ProductType } from "../../../types/types";

export type ButtonsProps = {
  handleCheckInStoreStockClick: () => void;
  productType?: ProductType;
  showStoreStockButton: boolean;
};

export const Buttons = ({
  handleCheckInStoreStockClick,
  productType,
  showStoreStockButton,
}: ButtonsProps) => {
  return (
    <div className={styles.buttons}>
      {showStoreStockButton && productType !== "RetiredStaticBundle" && (
        <TertiaryButton
          small
          IconComponent={InStore24PxOutlined}
          data-testid="skiplinks:top-box-store-stock"
          onClick={handleCheckInStoreStockClick}
        >
          Check in-store stock
        </TertiaryButton>
      )}
    </div>
  );
};
